import styles from "./index.module.css";
function Divider() {
  return <div className={styles.divider}></div>;
}

export default Divider;
